import React, { useState, useEffect, Fragment } from 'react';
import Api from '../../Api';
import { useParams, Link } from 'react-router-dom';
import Loader from '../../Components/Utils/Loader';
import { FormattedMessage } from 'react-intl';
import { withAuth } from '../../hoc/Auth';

import classes from './styles.module.css';

export const STATUS = {
    LOADING: 'loading',
    SUCCESS: 'success',
    INVALID: 'invalid',
    FAILED: 'failed',
};

/**
 * Подтверждение кода из письма. Отказ запроса (сеть, 5xx) — отдельный исход:
 * раньше его не ловили, и страница навсегда оставалась на загрузчике.
 */
export function confirmEmailCode(api, code) {
    return api.sendConfirmationEmailCode(code).then(
        (r) => {
            if (r && r.error === false) {
                return STATUS.SUCCESS;
            }
            if (r && r.error === true) {
                return STATUS.INVALID;
            }
            return STATUS.FAILED;
        },
        () => STATUS.FAILED
    );
}

export function ConfirmationView({ status, isAuthorized }) {
    if (status === STATUS.LOADING) {
        return (
            <div className={classes.ConfirmPage}>
                <div className={classes.Container}>
                    <Loader />
                </div>
            </div>
        );
    }

    // Уже вошедшего ведём в кабинет, остальных — на вход.
    const cabinetLink = isAuthorized ? (
        <Link to="/" className={classes.Btn}>
            <FormattedMessage id="Confirmation.btn.cabinet" defaultMessage="Перейти в кабинет" />
        </Link>
    ) : (
        <Link to="/login" className={classes.Btn}>
            <FormattedMessage id="Confirmation.btn.login" defaultMessage="Войти в кабинет" />
        </Link>
    );

    let content;
    if (status === STATUS.SUCCESS) {
        content = (
            <Fragment>
                <div className={classes.SuccessIcon} />
                <h2 className={classes.Title}>
                    <FormattedMessage id="Confirmation.title.success" defaultMessage="Почта подтверждена" />
                </h2>
                <p className={classes.Text}>
                    <FormattedMessage
                        id="Confirmation.text.success"
                        defaultMessage="Новый адрес сохранён в профиле. Письма и уведомления теперь будут приходить на него."
                    />
                </p>
                <div className={classes.Actions}>{cabinetLink}</div>
            </Fragment>
        );
    } else if (status === STATUS.INVALID) {
        content = (
            <Fragment>
                <div className={classes.ErrorIcon} />
                <h2 className={classes.Title}>
                    <FormattedMessage id="Confirmation.title.error" defaultMessage="Ссылка недействительна" />
                </h2>
                <p className={classes.Text}>
                    <FormattedMessage
                        id="Confirmation.text.error"
                        defaultMessage="Возможно, адрес уже подтверждён по этой ссылке или смену почты запросили заново. Проверьте почту в профиле и при необходимости запросите смену ещё раз."
                    />
                </p>
                <div className={classes.Actions}>{cabinetLink}</div>
            </Fragment>
        );
    } else {
        content = (
            <Fragment>
                <div className={classes.ErrorIcon} />
                <h2 className={classes.Title}>
                    <FormattedMessage id="Confirmation.title.failed" defaultMessage="Не удалось подтвердить почту" />
                </h2>
                <p className={classes.Text}>
                    <FormattedMessage
                        id="Confirmation.text.failed"
                        defaultMessage="Проверьте подключение к интернету и попробуйте ещё раз. Если ошибка повторится, напишите в поддержку."
                    />
                </p>
                <div className={classes.Actions}>
                    <button type="button" className={classes.Btn} onClick={() => window.location.reload()}>
                        <FormattedMessage id="Confirmation.btn.retry" defaultMessage="Попробовать ещё раз" />
                    </button>
                    {React.cloneElement(cabinetLink, { className: `${classes.Btn} ${classes.BtnSecondary}` })}
                </div>
            </Fragment>
        );
    }

    return (
        <div className={classes.ConfirmPage}>
            <div className={classes.Container}>{content}</div>
        </div>
    );
}

function Confirmation({ isAuthorized }) {
    const { code } = useParams();
    const [status, setStatus] = useState(STATUS.LOADING);

    useEffect(() => {
        let active = true;
        confirmEmailCode(new Api(), code).then((result) => {
            if (active) {
                setStatus(result);
            }
        });
        return () => {
            active = false;
        };
    }, [code]);

    return <ConfirmationView status={status} isAuthorized={isAuthorized} />;
}

export default withAuth(Confirmation);



// WEBPACK FOOTER //
// ./src/PagesOfCommon/Сonfirmation/index.js